export const EventDispatchLogout = "RefabricDispatchLogout";
export const EventDispatchSnackbar = "RefabricDispatchSnackbar";
// REF-5421: a passwordless guest hit the must_set_password hard gate (403 from any
// authed endpoint). Routes to the set-password screen — NOT a logout.
export const EventDispatchSetPassword = "RefabricDispatchSetPassword";
// STRIPE P5-F2 (PD7): a gated route answered 403 `team_suspended`. Shows the suspended-team screen — NOT a logout.
export const EventDispatchTeamSuspended = "RefabricDispatchTeamSuspended";

// ----- EventDispatchSnackbar payload contract (Phase 5-6) -----
// Canonical i18n shape: `messageKey` (required for any human-visible text) + optional `params`.
// The dual-read shim (Phase 2a) is gone — callers MUST pass a translation key, not raw English.
// HttpClient's 402/503 dispatches fall back to `snackbar:402.default` / `snackbar:503.default` when
// the BE response does not include `error_code`, so the user always sees a localized message.
//
// Shape: { type, messageKey?: "errors.payment.card_declined", params?: {...}, screen?, panel?, ... }
export interface SnackbarEventDetail {
  type: number;
  messageKey?: string;
  params?: Record<string, unknown>;
  screen?: unknown;
  panel?: string;
  messageType?: string;
  popupType?: string;
  popupReason?: string;
  // REF-5398/REF-5453: credit-gate 402 shortfall numbers (main pool only on dual-bucket gates).
  requiredCredits?: number | null;
  remainingCredits?: number | null;
}
